import React, { useState } from "react"
import { Badge, Button, Card, CardBody, Table } from "reactstrap"

import MessageModal from "./MessageModal"
import { STRATEGY_LABELS } from "./constants"

/**
 * A listing of stored facility replies. The reply text IS the link that opens it -- there is
 * no separate "view" column, since the thing the reader wants to click is the thing they are
 * already reading.
 *
 * Used for both of the page's reply sets -- the ones under the pasted QD Ref, and the
 * location's recent history -- because they are the same shape and the reader should not
 * have to learn two grids. What differs is only the title and which button validates them.
 */
function ReplyList({ title, hint, replies, emptyText, action }) {
  const [viewing, setViewing] = useState(null)
  const rows = replies || []

  return (
    <Card className="mb-3">
      <CardBody>
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div>
            <h6 className="mb-0">
              {title}{" "}
              <span className="text-muted fw-normal">({rows.length})</span>
            </h6>
            {hint && <div className="text-muted" style={{ fontSize: "0.72rem" }}>{hint}</div>}
          </div>
          {action}
        </div>

        {rows.length === 0 ? (
          <div className="text-muted small">{emptyText}</div>
        ) : (
          <Table bordered hover size="sm" className="small mb-0">
            <thead className="table-light">
              <tr>
                <th style={{ width: 128 }}>Received</th>
                <th>Reply</th>
                <th style={{ width: 150 }}>Processed as</th>
                <th style={{ width: 96 }}>Reviewer</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(r => (
                <tr key={`${r.mail_tracker}-${r.message_id}`}>
                  <td className="text-nowrap text-muted">
                    {r.response_rcvd_on ? r.response_rcvd_on.replace("T", " ").slice(0, 16) : "—"}
                  </td>
                  <td>
                    <Button color="link" size="sm"
                            className="p-0 text-start text-decoration-none align-baseline"
                            title="Open the full reply"
                            onClick={() => setViewing(r)}>
                      {r.snippet || "(empty)"}
                    </Button>
                  </td>
                  {/* The strategy that handled this reply in production, which is also the
                      one a preview replays it under. */}
                  <td className="text-muted" title={r.confirmation_strategy || ""}>
                    {STRATEGY_LABELS[r.confirmation_strategy] || r.confirmation_strategy || "—"}
                  </td>
                  <td>
                    {r.human_said ? <Badge color="info">{r.human_said}</Badge>
                                  : <span className="text-muted">—</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardBody>
      <MessageModal reply={viewing} onClose={() => setViewing(null)} />
    </Card>
  )
}

export default ReplyList
